import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const exitSearch = action(
    'EXIT_SEARCH_NEXT',
    (actionSource: string, scenarioId: SearchScenarioId) => ({
        actionSource,
        scenarioId,
    })
);

export default exitSearch;
